import { render, staticRenderFns } from "./DeliveryPanel.vue?vue&type=template&id=529b0558&scoped=true"
import script from "./DeliveryPanel.vue?vue&type=script&lang=js"
export * from "./DeliveryPanel.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPanel.vue?vue&type=style&index=0&id=529b0558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b0558",
  null
  
)

export default component.exports